import React, { Component } from "react";
import Constant from "../../../Constant";

export default class Youtube extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      topicName: props.name || "",
      topicDiscription: props.desc || "",
      topicYoutubeVideo: props.videoURL || "",
      image: props.image || "",
      topicCatagoryId: "youtube",
      courseId: props.data,
    };
  }

  onInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  uploadImg = (event) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new FormData();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("media", event.target.files[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/media/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data[0]);
        this.setState({
          image: result.data[0].url,
        });
      })
      .catch((error) => console.log("error", error));
  };

  updateRecord = () => {
    console.log("Updat");
    const {
      topicName,
      topicDiscription,
      topicYoutubeVideo,
      topicCatagoryId,
      courseId,
    } = this.state;

    const data = {
      name: topicName,
      description: topicDiscription,
      content: {
        videoURL: topicYoutubeVideo,
        topicType: topicCatagoryId,
      },
      contentType: topicCatagoryId,
      courseId: courseId,
    };
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("topicId", this.props.topicID);
    urlencoded.append("name", data.name);
    urlencoded.append("description", data.description);
    urlencoded.append("image", data.image);
    urlencoded.append("content", JSON.stringify(data.content));
    urlencoded.append("contentType", data.contentType);
    urlencoded.append("start", new Date().toISOString());
    // urlencoded.append("end", data.contentType);
    urlencoded.append("isLive", false);
    urlencoded.append("duration", "15");
    console.log(data.courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/update", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  onSubmit = () => {
    console.log("Submit");

    const {
      topicName,
      topicDiscription,
      topicYoutubeVideo,
      topicCatagoryId,
      courseId,
    } = this.state;
    const data = {
      name: topicName,
      description: topicDiscription,
      image: this.state.image,
      content: {
        videoURL: topicYoutubeVideo,
        topicType: topicCatagoryId,
      },
      contentType: topicCatagoryId,
      courseId: courseId,
    };
    console.log(data);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    let urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", data.courseId);
    urlencoded.append("name", data.name);
    urlencoded.append("description", data.description);
    urlencoded.append("image", data.image);
    urlencoded.append("content", JSON.stringify(data.content));
    urlencoded.append("contentType", data.contentType);
    urlencoded.append("start", new Date().toISOString());
    // urlencoded.append("end", data.contentType);
    urlencoded.append("isLive", false);
    urlencoded.append("duration", "15");
    let postRequestOption = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };
    fetch(Constant.getAPI() + "/topic/add	", postRequestOption)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    console.log("HELO", this.props.name);

    return (
      <div>
        <hr />
        <div class="form-group">
          <div className="col-md-10">
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Topic Name
              </label>
              {this.props.name ? (
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Topic Name"
                  id="inputDefault"
                  name="topicName"
                  value={this.state.topicName}
                  readOnly
                />
              ) : (
                  <input
                    type="text"
                    class="form-control col-8"
                    placeholder="Enter Topic Name"
                    id="inputDefault"
                    name="topicName"
                    value={this.state.topicName}
                    onChange={this.onInputChange}
                  />
                )}
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Discription
              </label>
              <textarea
                type="text"
                class="form-control col-8"
                placeholder="Add Topic Discription"
                id="inputDefault"
                name="topicDiscription"
                value={this.state.topicDiscription}
                onChange={this.onInputChange}
              />
            </div>

            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Upload Youtube Video
              </label>
              <input
                type="text"
                class="form-control col-8"
                placeholder="Enter Youtube Video URL"
                id="inputDefault"
                name="topicYoutubeVideo"
                value={this.state.topicYoutubeVideo}
                onChange={this.onInputChange}
              />
            </div>

            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Topic Catagory
              </label>
              <input
                type="text"
                class="form-control col-8"
                id="inputDefault"
                name="topicCatagoryId"
                value={this.state.topicCatagoryId}
                onChange={this.onInputChange}
                readOnly
              />
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Upload Topic Image
              </label>
              <input
                type="file"
                name="selectedFile"
                onChange={this.uploadImg}
                multiple
              />
              <div className="col-8 p-0"></div>
            </div>

            <div className="row">
              <div className="col-4"></div>
              <div className="col-8 p-0">
                {" "}
                {this.props.name ? (
                  <button
                    onClick={this.updateRecord}
                    className="btn btn-primary"
                    name="submit"
                  >
                    Edit and View
                  </button>
                ) : (
                    <button
                      onClick={this.onSubmit}
                      className="btn btn-primary"
                      name="submit"
                    >
                      Save and View
                    </button>
                  )}{" "}
                or{" "}
                <a href={`#/admin/course/topics/${this.state.courseID}`}>
                  Cancel
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
